"use client";

import React, { useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
const categories = [{
  id: "lighting",
  label: "Lighting"
}, {
  id: "vacuums",
  label: "Vacuums"
}, {
  id: "climate",
  label: "Climate Control"
}];
const products = [{
  id: "p1",
  categoryId: "lighting",
  name: "Ambient Smart Bulb",
  price: "$49.00",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647152/img/smart_lighting_interior.png"
}, {
  id: "p2",
  categoryId: "vacuums",
  name: "Robotic Floor Specialist",
  price: "$599.00",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647152/img/clean_floor_vacuum.png"
}, {
  id: "p3",
  categoryId: "climate",
  name: "Adaptive Thermostat",
  price: "$249.00",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647152/img/climate_control_unit.png"
}, {
  id: "p4",
  categoryId: "lighting",
  name: "Architectural Strip Light",
  price: "$89.00",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647152/img/architectural_lighting.png"
}, {
  id: "p5",
  categoryId: "vacuums",
  name: "Handheld Precision Vac",
  price: "$129.00",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647152/img/precision_vacuum_detail.png"
}, {
  id: "p6",
  categoryId: "climate",
  name: "Smart Air Purifier",
  price: "$349.00",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647152/img/air_purifier_minimal.png"
}];
export default function OurInventory() {
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const handleCategoryChange = (categoryId: string) => {
    setSelectedCategories(prev => prev.includes(categoryId) ? prev.filter(id => id !== categoryId) : [...prev, categoryId]);
  };
  const filteredProducts = products.filter(product => selectedCategories.length === 0 || selectedCategories.includes(product.categoryId));
  return <section data-section-id="222820" id="category-overview" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="mb-12 text-center md:text-left">
          <h2 className="font-default text-3xl md:text-4xl font-bold text-foreground mb-4 tracking-tight">
            Smart Ecosystem
          </h2>
          <p className="text-muted-foreground max-w-2xl text-lg font-default">
            Explore our curated selection of high-end devices designed to integrate seamlessly into your modern home.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8">
          {}
          <aside className="w-full lg:w-64 shrink-0">
            <div className="bg-card rounded-2xl p-6 shadow-sm border border-border/40 sticky top-24">
              <h3 className="font-default text-xs font-bold uppercase tracking-widest text-muted-foreground mb-4 pb-4 border-b border-border">
                Filter By
              </h3>
              <div className="space-y-4">
                {categories.map((category, i) => <div key={category.id} data-index={i} className="flex items-center space-x-3">
                    <Checkbox id={`category-${category.id}`} checked={selectedCategories.includes(category.id)} onCheckedChange={() => handleCategoryChange(category.id)} className="border-muted-foreground/30" />
                    <Label htmlFor={`category-${category.id}`} className="text-sm font-default font-medium cursor-pointer text-foreground/80">
                      {category.label}
                    </Label>
                  </div>)}
              </div>
            </div>
          </aside>

          {}
          <div className="flex-1">
            {filteredProducts.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
                {filteredProducts.map((product, i) => <Card key={product.id} data-index={i} className="overflow-hidden flex flex-col h-full border-none bg-card shadow-[0px_10px_40px_rgba(0,0,0,0.04)] hover:shadow-[0px_15px_50px_rgba(0,0,0,0.08)] hover:scale-[1.02] transition-all duration-500 rounded-2xl">
                    <div className="aspect-square bg-muted/20 p-0 flex items-center justify-center relative group overflow-hidden">
                      <img src={product.image} alt={product.name} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-110" />
                    </div>
                    <CardHeader className="pb-2 pt-6">
                      <div className="text-[12px] text-muted-foreground font-bold uppercase tracking-widest mb-1 font-default">
                        {categories.find(c => c.id === product.categoryId)?.label}
                      </div>
                      <CardTitle className="font-default text-2xl font-semibold leading-tight text-foreground">
                        {product.name}
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="flex-1 pb-4">
                      <p className="text-lg font-default font-medium text-muted-foreground">
                        {product.price}
                      </p>
                    </CardContent>
                    <CardFooter className="flex flex-col gap-3 pt-0">
                      <Button variant="outline" className="w-full bg-transparent border-border hover:bg-accent rounded-full font-default text-sm" asChild>
                        <Link to={`/devices/${product.id}`}>View Details</Link>
                      </Button>
                      <Button className="w-full rounded-full bg-primary text-primary-foreground font-default text-sm" asChild>
                        <Link to="#">
                          Inquire Now
                        </Link>
                      </Button>
                    </CardFooter>
                  </Card>)}
              </div> : <div className="flex flex-col items-center justify-center py-24 text-center bg-card rounded-2xl border border-border/50 border-dashed">
                <p className="text-muted-foreground text-lg mb-4 font-default">
                  No devices found in this category.
                </p>
                <Button variant="outline" className="rounded-full" onClick={() => setSelectedCategories([])}>
                  Reset Selection
                </Button>
              </div>}
          </div>
        </div>
      </div>
    </section>;
}